module.exports = __webpack_public_path__ + "static/site-1748617940196/img/logo_visa.5f04499f.svg";